<form [formGroup]="form">
  <div
    class="header h-[55px] flex justify-start items-center pl-[50px] mb-[23px] bg-[#DEE2E6]"
  >
    <p class="!m-0">Request for Quotation (RFQ)</p>
    <p
      class="text-[#] !mt-[10px] text-[14px] font-semibold bg-white rounded-full !ml-[15px] px-[13px] !h-[24px] flex items-center justify-center"
    >
      Required Documentation
    </p>
  </div>
  <p class="subTitle pl-[28px]">Commercial Submission:</p>
  <p class="label pl-[28px]">Price Breakdown</p>

  <div class="!px-[30px] grid grid-cols-1 md:grid-cols-1 lg:grid-cols-1">
    <div class="rounded w-[100%] p-0 !pb-0 !pt-0">
      <mat-form-field class="!w-[50%]" appearance="outline">
        <mat-label> Title</mat-label>
        <input
          matInput
          type="text"
          formControlName="title"
          placeholder="Title"
        />
      </mat-form-field>
      <div
        *ngIf="form.get('title').invalid && form.get('title').touched"
        class=""
      >
        <span style="color: red">Title is required</span>
      </div>
    </div>
    <div class="rounded p-0 !pb-0 !pt-0 w-[100%] mt-[8px]">
      <mat-form-field class="!w-[100%]" appearance="outline">
        <mat-label>Description</mat-label>
        <textarea
          matInput
          rows="4"
          formControlName="description_control"
          placeholder="Description"
        ></textarea>
      </mat-form-field>
      <div
        *ngIf="
          form.get('description_control').invalid &&
          form.get('description_control').touched
        "
      >
        <span style="color: red">Description is required</span>
      </div>
    </div>
    <span class="label mt-[56px]"> Financial Stability </span>
    <div class="rounded p-0 !pb-0 !pt-0 w-[100%] mt-[8px]">
      <mat-form-field class="!w-[100%]" appearance="outline">
        <mat-label>Financial Stability</mat-label>
        <textarea
          matInput
          rows="4"
          formControlName="financial_stability_control"
          placeholder="Financial Stability"
        ></textarea>
      </mat-form-field>
      <div
        *ngIf="
          form.get('financial_stability_control').invalid &&
          form.get('financial_stability_control').touched
        "
      >
        <span style="color: red">Financial stability is required</span>
      </div>
    </div>
    <div class="flex items-center justify-start mt-[61px]">
      <button
        type="button"
        class="attach_document px-2 py-[0.2rem] focus:outline-none flex justify-start items-center"
        (click)="financial_stability_file.click()"
      >
        <span class="text-[0.7rem]"> Attach Document </span>
        <img
          class="rounded-full ml-[4px]"
          src="assets/icons/document.svg"
          alt="document icon"
        />
      </button>
      <input
        type="file"
        #financial_stability_file
        (change)="onFileUpload($event, 'financial_stability_file_control')"
        multiple
        hidden
      />
      <img
        (click)="financial_stability_file.click()"
        class="rounded-full ml-[8px] w-[18px] cursor-pointer"
        src="assets/images/add_icon.png"
        alt="add icon"
      />
    </div>

    <!-- old attachment -->
    <div
      class="flex flex-col"
      *ngFor="
        let oldFinancialStabilityFile of oldFinancialStabilityFiles;
        let i = index
      "
    >
      <div class="flex items-start mt-[11px]">
        <div class="flex justify-start items-center">
          <div
            class="relative ml-[5px] w-[2rem] h-[2rem] border border-gray-300 rounded-md overflow-hidden"
          >
            <!-- Check if the uploaded file is an image -->
            <img
              [src]="getFileIcon(oldFinancialStabilityFile)"
              alt="File Preview"
              class="object-cover w-auto h-[100%] cursor-pointer"
            />
          </div>
        </div>

        <!-- Display File Name -->
        <span
          style="
            color: black;
            text-align: left;
            font-size: 18px;
            white-space: nowrap;
            text-overflow: ellipsis;
            display: inline-block;
            overflow: visible;
            margin-left: 10px;
            margin-top: 5px;
          "
        >
          {{ oldFinancialStabilityFile?.title }}
        </span>

        <!-- Remove File Button -->
        <img
          src="assets/icons/trash.svg"
          alt="trash"
          class="object-cover w-auto cursor-pointer ml-[8px] mt-[8px]"
          (click)="
            removeOldFile(
              i,
              oldFinancialStabilityFile?.id,
              'financial_stability_file_control'
            )
          "
        />
      </div>
    </div>

    <!-- New attachment -->
    <div
      class="flex flex-col"
      *ngFor="
        let fileControl of financial_stability_file_control.controls;
        let i = index
      "
    >
      <div class="flex items-start mt-[11px]">
        <div class="flex justify-start items-center">
          <div
            class="relative ml-[5px] w-[2rem] h-[2rem] border border-gray-300 rounded-md overflow-hidden"
          >
            <!-- Check if the uploaded file is an image -->
            <img
              [src]="getFileIcon(fileControl.value)"
              alt="File Preview"
              class="object-cover w-auto h-[100%] cursor-pointer"
            />
          </div>
        </div>

        <!-- Display File Name -->
        <span
          style="
            color: black;
            text-align: left;
            font-size: 18px;
            white-space: nowrap;
            text-overflow: ellipsis;
            display: inline-block;
            overflow: visible;
            margin-left: 10px;
            margin-top: 5px;
          "
        >
          {{ fileControl.value.name }}
        </span>

        <!-- Remove File Button -->
        <img
          src="assets/icons/trash.svg"
          alt="trash"
          class="object-cover w-auto cursor-pointer ml-[8px] mt-[8px]"
          (click)="removeFile(i, 'financial_stability_file_control')"
        />
      </div>
    </div>

    <span class="label mt-[18px]"> Contractual comments</span>
    <app-rich-textEditor
      (contentChange)="setContractualComments($event)"
      [resetEditor]="resetRichTextEditor"
      [richTextValue]="form.get('contractual_comments_control')?.value"
    ></app-rich-textEditor>

    <span class="label mt-[18px]">Proof of Insurance</span>
    <div class="flex items-center justify-start mt-[14px]">
      <button
        type="button"
        class="attach_document px-2 py-[0.2rem] focus:outline-none flex justify-start items-center"
        (click)="proof_of_insurance.click()"
      >
        <span class="text-[0.7rem]"> Attach Document </span>
        <img
          class="rounded-full ml-[4px]"
          src="assets/icons/document.svg"
          alt="document icon"
        />
      </button>
      <input
        type="file"
        #proof_of_insurance
        (change)="onFileUpload($event, 'proof_of_insurance_file_control')"
        multiple
        hidden
      />
      <img
        (click)="proof_of_insurance.click()"
        class="rounded-full ml-[8px] w-[18px] cursor-pointer"
        src="assets/images/add_icon.png"
        alt="add icon"
      />
    </div>

    <!-- old attachment -->
    <div
      class="flex flex-col"
      *ngFor="
        let oldProofOfInsuranceFile of oldProofOfInsuranceFiles;
        let i = index
      "
    >
      <div class="flex items-start mt-[11px]">
        <div class="flex justify-start items-center">
          <div
            class="relative ml-[5px] w-[2rem] h-[2rem] border border-gray-300 rounded-md overflow-hidden"
          >
            <!-- Check if the uploaded file is an image -->
            <img
              [src]="getFileIcon(oldProofOfInsuranceFile)"
              alt="File Preview"
              class="object-cover w-auto h-[100%] cursor-pointer"
            />
          </div>
        </div>

        <!-- Display File Name -->
        <span
          style="
            color: black;
            text-align: left;
            font-size: 18px;
            white-space: nowrap;
            text-overflow: ellipsis;
            display: inline-block;
            overflow: visible;
            margin-left: 10px;
            margin-top: 5px;
          "
        >
          {{ oldProofOfInsuranceFile?.title }}
        </span>

        <!-- Remove File Button -->
        <img
          src="assets/icons/trash.svg"
          alt="trash"
          class="object-cover w-auto cursor-pointer ml-[8px] mt-[8px]"
          (click)="
            removeOldFile(
              i,
              oldProofOfInsuranceFile?.id,
              'proof_of_insurance_file_control'
            )
          "
        />
      </div>
    </div>

    <!-- New attachment -->
    <div
      class="flex flex-col"
      *ngFor="
        let fileControl of proof_of_insurance_file_control.controls;
        let i = index
      "
    >
      <div class="flex items-start mt-[11px]">
        <div class="flex justify-start items-center">
          <div
            class="relative ml-[5px] w-[2rem] h-[2rem] border border-gray-300 rounded-md overflow-hidden"
          >
            <!-- Check if the uploaded file is an image -->
            <img
              [src]="getFileIcon(fileControl?.value)"
              alt="File Preview"
              class="object-cover w-auto h-[100%] cursor-pointer"
            />
          </div>
        </div>

        <!-- Display File Name -->
        <span
          style="
            color: black;
            text-align: left;
            font-size: 18px;
            white-space: nowrap;
            text-overflow: ellipsis;
            display: inline-block;
            overflow: visible;
            margin-left: 10px;
            margin-top: 5px;
          "
        >
          {{ fileControl.value.name }}
        </span>

        <!-- Remove File Button -->
        <img
          src="assets/icons/trash.svg"
          alt="trash"
          class="object-cover w-auto cursor-pointer ml-[8px] mt-[8px]"
          (click)="removeFile(i, 'proof_of_insurance_file_control')"
        />
      </div>
    </div>

    <span class="label mt-[18px]">Performance Bond/Guarantee</span>
    <div class="flex items-center justify-start mt-[14px]">
      <button
        type="button"
        class="attach_document px-2 py-[0.2rem] focus:outline-none flex justify-start items-center"
        (click)="performance_bond.click()"
      >
        <span class="text-[0.7rem]"> Attach Document </span>
        <img
          class="rounded-full ml-[4px]"
          src="assets/icons/document.svg"
          alt="document icon"
        />
      </button>
      <input
        type="file"
        #performance_bond
        (change)="onFileUpload($event, 'performance_bond_file_control')"
        multiple
        hidden
      />
      <img
        (click)="performance_bond.click()"
        class="rounded-full ml-[8px] w-[18px] cursor-pointer"
        src="assets/images/add_icon.png"
        alt="add icon"
      />
    </div>
  </div>

  <!--Old attachment -->
  <div
    class="flex flex-col pl-[26px]"
    *ngFor="
      let oldPerformanceBondFile of oldPerformanceBondFiles;
      let i = index
    "
  >
    <div class="flex items-start mt-[11px]">
      <div class="flex justify-start items-center">
        <div
          class="relative ml-[5px] w-[2rem] h-[2rem] border border-gray-300 rounded-md overflow-hidden"
        >
          <!-- Check if the uploaded file is an image -->
          <img
            [src]="getFileIcon(oldPerformanceBondFile)"
            alt="File Preview"
            class="object-cover w-auto h-[100%] cursor-pointer"
          />
        </div>
      </div>

      <!-- Display File Name -->
      <span
        style="
          color: black;
          text-align: left;
          font-size: 18px;
          white-space: nowrap;
          text-overflow: ellipsis;
          display: inline-block;
          overflow: visible;
          margin-left: 10px;
          margin-top: 5px;
        "
      >
        {{ oldPerformanceBondFile?.title }}
      </span>

      <!-- Remove File Button -->
      <img
        src="assets/icons/trash.svg"
        alt="trash"
        class="object-cover w-auto cursor-pointer ml-[8px] mt-[8px]"
        (click)="
          removeOldFile(
            i,
            oldPerformanceBondFile?.id,
            'performance_bond_file_control'
          )
        "
      />
    </div>
  </div>

  <!-- New attachment -->
  <div
    class="flex flex-col pl-[26px]"
    *ngFor="
      let fileControl of performance_bond_file_control.controls;
      let i = index
    "
  >
    <div class="flex items-start mt-[11px]">
      <div class="flex justify-start items-center">
        <div
          class="relative ml-[5px] w-[2rem] h-[2rem] border border-gray-300 rounded-md overflow-hidden"
        >
          <!-- Check if the uploaded file is an image -->
          <img
            [src]="getFileIcon(fileControl.value)"
            alt="File Preview"
            class="object-cover w-auto h-[100%] cursor-pointer"
          />
        </div>
      </div>

      <!-- Display File Name -->
      <span
        style="
          color: black;
          text-align: left;
          font-size: 18px;
          white-space: nowrap;
          text-overflow: ellipsis;
          display: inline-block;
          overflow: visible;
          margin-left: 10px;
          margin-top: 5px;
        "
      >
        {{ fileControl.value.name }}
      </span>

      <!-- Remove File Button -->
      <img
        src="assets/icons/trash.svg"
        alt="trash"
        class="object-cover w-auto cursor-pointer ml-[8px] mt-[8px]"
        (click)="removeFile(i, 'performance_bond_file_control')"
      />
    </div>
  </div>

  <div
    class="!pr-[32px] !mb-[30px] !mt-[49px] grid grid-cols-1 md:grid-cols-1 lg:grid-cols-1 gap-4"
  >
    <div class="!w-[100%] flex justify-end items-center">
      <button (click)="handleBack()" type="button" class="back-btn">
        Back
      </button>
      <button
        class="!w-[75px] !h-[39px] flex justify-center items-center !bg-[#E76B3F] !text-[#ffffff] !text-[16px] !rounded-[3px]"
        (click)="moveToNextStep()"
      >
        Next
      </button>
    </div>
  </div>
</form>
